export const getMarket = () => {
    if (window.location.host.indexOf('.cz') !== -1) {
        return 'cz';
    } else if (window.location.host.indexOf('.sk') !== -1) {
        return 'sk';
    } else if (window.location.host.indexOf('.pl') !== -1) {
        return 'pl';
    } else if (window.location.host.indexOf('.hu') !== -1) {
        return 'hu';
    } else if (window.location.host.indexOf('.ro') !== -1) {
        return 'ro';
    }

    return 'en';
};
